var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMici = function SvgMici(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M12 14.1a2.54 2.54 0 0 0 2.56-2.52l.01-5.05a2.57 2.57 0 0 0-5.14 0v5.05A2.55 2.55 0 0 0 12 14.1m4.54-2.52a4.41 4.41 0 0 1-4.54 4.3 4.41 4.41 0 0 1-4.54-4.3H6a5.91 5.91 0 0 0 5.14 5.66V20h1.72v-2.76A5.91 5.91 0 0 0 18 11.58z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMici);
export default ForwardRef;